/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DadosPessoaisAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  AUTOCOMPLETE_1 = 'autocomplete-1',
  AUTOCOMPLETE_2 = 'autocomplete-2',
  AUTOCOMPLETE_3 = 'autocomplete-3',
  AUTOCOMPLETE_4 = 'autocomplete-4',
  AUTOCOMPLETE_5 = 'autocomplete-5',
  CARD_0 = 'card-0',
  CELLPHONE_NUMBER = 'cellphone-number',
  CHECKBOX_0 = 'checkbox-0',
  CUSTOM_CARD_DADOS_PESSOAIS = 'custom-card-dados-pessoais',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK_0 = 'deck-0',
  FETCH_0 = 'fetch-0',
  FETCH_2 = 'fetch-2',
  FETCH_3 = 'fetch-3',
  FETCH_4 = 'fetch-4',
  FETCH_5 = 'fetch-5',
  FETCH_6 = 'fetch-6',
  FETCH_7 = 'fetch-7',
  FETCH_DADOS_PESSOAIS = 'fetch-dados-pessoais',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_7 = 'field-7',
  FIELD_8 = 'field-8',
  FIELD_9 = 'field-9',
  FIELD_10 = 'field-10',
  FIELD_11 = 'field-11',
  FIELD_12 = 'field-12',
  FIELD_13 = 'field-13',
  FIELD_14 = 'field-14',
  FIELD_15 = 'field-15',
  FIELD_16 = 'field-16',
  FIELD_17 = 'field-17',
  FIELD_18 = 'field-18',
  FIELD_19 = 'field-19',
  FIELD_21 = 'field-21',
  FIELD_22 = 'field-22',
  FIELD_23 = 'field-23',
  FIELD_24 = 'field-24',
  FIELD_26 = 'field-26',
  FIELD_27 = 'field-27',
  FIELD_28 = 'field-28',
  FIELD_29 = 'field-29',
  FIELD_ANEXOS = 'field-anexos',
  FIELD_CEP = 'field-cep',
  FIELD_ESTADO = 'field-estado',
  FIELD_TERMO = 'field-termo',
  FILE_UPLOADER = 'file-uploader',
  FORM = 'form',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_2 = 'input-2',
  INPUT_3 = 'input-3',
  INPUT_4 = 'input-4',
  INPUT_5 = 'input-5',
  INPUT_6 = 'input-6',
  INPUT_7 = 'input-7',
  INPUT_8 = 'input-8',
  INPUT_9 = 'input-9',
  INPUT_10 = 'input-10',
  INPUT_11 = 'input-11',
  INPUT_12 = 'input-12',
  INPUT_13 = 'input-13',
  INPUT_14 = 'input-14',
  INPUT_15 = 'input-15',
  LAYOUT_DADOS_PESSOAIS = 'layout-dados-pessoais',
  LINK_TERMOS = 'link-termos',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  MAPPER_2 = 'mapper-2',
  MAPPER_3 = 'mapper-3',
  MAPPER_4 = 'mapper-4',
  MAPPER_5 = 'mapper-5',
  MAPPER_6 = 'mapper-6',
  MAPPER_7 = 'mapper-7',
  PANEL_0 = 'panel-0',
  PHONE_NUMBER = 'phone-number',
  TAB_CHANGED_INFO = 'tab-changed-info',
  TAB_CONTROL_0 = 'tab-control-0',
  TAB_WITH_CONTENT_0 = 'tab-with-content-0',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_8 = 'text-8',
  TEXT_9 = 'text-9',
}
export { DadosPessoaisAliases };
